import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-b18dccae"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "no-sailing" }
const _hoisted_2 = { class: "no-sailing-title h4" }
const _hoisted_3 = { class: "no-sailing-message" }
const _hoisted_4 = { class: "no-sailing-message" }

import { Icon, DictionaryItemWithLink } from '../../Atoms';


export default /*#__PURE__*/_defineComponent({
  __name: 'NoSailingsAvailable',
  props: {
    text1: {},
    text2: {},
    baseUrl: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(Icon), {
      "icon-name": "noSailing",
      class: "no-sailing-icon"
    }),
    _createElementVNode("h2", _hoisted_2, _toDisplayString(_ctx.$t('No sailings title')), 1),
    _createElementVNode("p", _hoisted_3, [
      _createVNode(_unref(DictionaryItemWithLink), {
        text: _ctx.text1,
        "base-url": _ctx.baseUrl
      }, null, 8, ["text", "base-url"])
    ]),
    _createElementVNode("p", _hoisted_4, [
      _createVNode(_unref(DictionaryItemWithLink), {
        text: _ctx.text2,
        "base-url": _ctx.baseUrl
      }, null, 8, ["text", "base-url"])
    ])
  ]))
}
}

})